import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "skills__suggestions-label"
}

import {PropType} from 'vue';

    interface Skill {
        name: string;
        disabled: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SuggestionsSkillsV2',
  props: {
        skills: {type: Array as PropType<Skill[]>, required: true},
        label: String,
        selectable: {type: Boolean, default: true},
    },
  emits: ["select"],
  setup(__props, { emit: __emit }) {

    

    const emits = __emit;

    function pickSkill(skill: Skill): void {
        emits('select', skill.name);
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_tag = _resolveComponent("joy-tag")!
  const _component_joy_tags_list = _resolveComponent("joy-tags-list")!

  return (_openBlock(), _createBlock(_component_joy_tags_list, {
    class: "skills__suggestions",
    "data-testid": "malt-plus-brief-autocomplete-skills-suggestions"
  }, {
    default: _withCtx(() => [
      (__props.skills.length > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.skills, (skill) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (!skill.disabled)
            ? (_openBlock(), _createBlock(_component_joy_tag, {
                key: skill.name,
                "data-testid": "malt-plus-brief-autocomplete-skills-suggestion",
                variant: "secondary",
                tabindex: !skill.disabled ? 0 : -1,
                selectable: __props.selectable,
                onClick: ($event: any) => (pickSkill(skill))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(skill.name), 1)
                ]),
                _: 2
              }, 1032, ["tabindex", "selectable", "onClick"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ]),
    _: 1
  }))
}
}

})